import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface PinterestIconProps extends IconWrapperProps {
  backFillColor: string;
  frontFillColor: string;
}

const PinterestIcon = ({
  backFillColor,
  frontFillColor,
  ...rest
}: PinterestIconProps) => (
  <span>
    <IconWrapper
      width="40px"
      viewBox="0 0 40 40"
      title="Pinterest Link"
      {...rest}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g>
          <rect
            fill={backFillColor}
            x="0"
            y="0"
            width="40px"
            height="40px"
            rx="20"
          />
          <g
            transform="translate(13.000000, 10.000000)"
            fill={frontFillColor}
            fillRule="nonzero"
          >
            <path d="M8.16,0.02 C4.056,0.02 0,2.756 0,7.184 C0,10 1.584,11.6 2.544,11.6 C2.94,11.6 3.168,10.496 3.168,10.184 C3.168,9.812 2.22,9.02 2.22,7.472 C2.22,4.256 4.668,1.976 7.836,1.976 C10.56,1.976 12.576,3.524 12.576,6.368 C12.576,8.492 11.724,12.476 8.964,12.476 C7.968,12.476 7.116,11.756 7.116,10.724 C7.116,9.212 8.172,7.748 8.172,6.188 C8.172,3.54 4.416,4.02 4.416,7.22 C4.416,7.892 4.5,8.636 4.8,9.248 C4.248,11.624 3.12,15.164 3.12,17.612 C3.12,18.368 3.228,19.112 3.3,19.868 C3.436,20.02 3.368,20.004 3.576,19.928 C5.592,17.168 5.52,16.628 6.432,13.016 C6.924,13.952 8.196,14.456 9.204,14.456 C13.452,14.456 15.36,10.316 15.36,6.584 C15.36,2.612 11.928,0.02 8.16,0.02 Z" />
          </g>
        </g>
      </g>
    </IconWrapper>
  </span>
);

export default memo(PinterestIcon);
